import type { FeatureFlags } from '../../domain/models/FeatureFlags';
import { useGetFeatureFlagsQuery } from '../../infra/adapters/featureFlagsApiSlice';

const DEFAULT_FLAGS: FeatureFlags = { isSoftLoginEnabled: false };

export function useFeatureFlags(): { flags: FeatureFlags; isLoading: boolean; isError: boolean } {
  const { data, isLoading, isError } = useGetFeatureFlagsQuery(undefined);

  if (isError) {
    console.warn('[FeatureFlags] Failed to fetch /bs-util/properties — all flags defaulting to off.');
  }

  return {
    flags: data ?? DEFAULT_FLAGS,
    isLoading,
    isError,
  };
}
